// import React, { useEffect, useState } from 'react';
// import dayjs from 'dayjs';
// import axios from 'axios';
// import JSZip from 'jszip';
// import { saveAs } from 'file-saver';
// import styled from '@emotion/styled';
// import { DataGrid } from '@mui/x-data-grid';
// import { GridToolbarContainer } from '@mui/x-data-grid';
// import OpaqueLoading from '../../components/opaqueLoading/opaqueLoading';
// import {
//   IconButton,
//   FormControl,
//   FormControlLabel,
//   Radio,
//   RadioGroup,
//   Box,
//   Grid,
//   TextField,
//   Select,
//   MenuItem,
//   Button,
//   Card,
//   Typography,
//   Dialog,
//   DialogTitle,
//   DialogContent,
// } from '@mui/material';

// import { Stack, Tooltip } from '@mui/material';
// import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';

// import RefreshIcon from '@mui/icons-material/Refresh';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import * as XLSX from 'xlsx';

// import Sidebar from '../../components/common/sidebar/Sidebar';
// import CustomHeader from '../../components/common/header/CustomHeader';

// const isMobile = window.innerWidth < 900;

// const Container = styled.div`
//   width: 100%;
//   overflow-x: hidden;
// `;

// const DataGridContainer = styled.div`
//   width: 100%;
//   && .highlighted-row {
//     background-color: #ffcccb !important;
//   }
// `;

// function PdfIframe({ url }) {
//   console.log('url', url);
//   const [blobUrl, setBlobUrl] = React.useState(null);

//   React.useEffect(() => {
//     let revoke;
//     (async () => {
//       const res = await fetch(url, {
//         /* credentials/headers if needed */
//       });
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const blob = await res.blob();
//       const objUrl = URL.createObjectURL(
//         new Blob([blob], { type: 'application/pdf' })
//       );
//       revoke = objUrl;
//       setBlobUrl(objUrl);
//     })();
//     return () => revoke && URL.revokeObjectURL(revoke);
//   }, [url]);

//   return blobUrl ? (
//     <iframe
//       src={blobUrl}
//       style={{ width: '100%', height: '80vh', border: 'none' }}
//       title='PDF'
//     />
//   ) : (
//     <div>Loading…</div>
//   );
// }

// const CustomToolbar = ({ onAgreeDisagree }) => {
//   const [selectedOption, setSelectedOption] = useState('agree');
//   const handleRadioChange = (event) => {
//     const value = event.target.value;
//     onAgreeDisagree(value);
//     setSelectedOption(value);
//   };

//   return (
//     <GridToolbarContainer>
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//         <FormControl
//           component='fieldset'
//           sx={{
//             display: 'flex',
//             flexDirection: 'row',
//             borderRadius: '40px',
//             padding: '5px 10px',
//           }}
//         >
//           <RadioGroup row value={selectedOption} onChange={handleRadioChange}>
//             <FormControlLabel
//               value='agree'
//               control={<Radio sx={{ color: '#85c225' }} />}
//               label='Agree'
//               labelPlacement='end'
//               sx={{ '& .MuiFormControlLabel-label': { color: '#85c225' } }}
//             />
//             <FormControlLabel
//               value='disagree'
//               control={<Radio sx={{ color: '#85c225' }} />}
//               label='Disagree'
//               labelPlacement='end'
//               sx={{ '& .MuiFormControlLabel-label': { color: '#85c225' } }}
//             />
//           </RadioGroup>
//         </FormControl>
//       </Box>
//     </GridToolbarContainer>
//   );
// };

// const quarters = {
//   Q1: { start: '04-01', end: '06-30' },
//   Q2: { start: '04-01', end: '09-30' },
//   Q3: { start: '04-01', end: '12-31' },
//   Q4: { start: '04-01', end: '03-31' },
// };
// // const currentYear = new Date().getFullYear(); // as of now its static but need to implement dyanamic
// // const initialStartDate =
// //   quarters.Q1.start &&
// //   dayjs(`${currentYear}-${quarters.Q1.start}`).format('YYYY/MM/DD');
// // const initialEndDate =
// //   quarters.Q1.end &&
// //   dayjs(`${currentYear}-${quarters.Q1.end}`).format('YYYY/MM/DD');

// // Base year: use previous year until April arrives
// const today = dayjs();
// const currentYear = today.year();
// const baseYear = today.month() < 3 ? currentYear - 1 : currentYear;

// // For Q1 initial range
// const initialStartDate =
//   quarters.Q1.start &&
//   dayjs(`${baseYear}-${quarters.Q1.start}`).format('YYYY/MM/DD');

// const initialEndDate =
//   quarters.Q1.end &&
//   dayjs(`${baseYear}-${quarters.Q1.end}`).format('YYYY/MM/DD');

// const FinanceManagement = () => {
//   const [agreeDisagree, setAgreeDisagree] = useState('agree');
//   const [isloader, setIsloader] = React.useState(false);
//   const [selectedRowIds, setSelectedRowIds] = useState([]);
//   const [distributorData, setDistributorData] = useState([]);
//   const [distributorData1, setDistributorData1] = useState([]);
//   const [view, setView] = useState(0);
//   const [open, setOpen] = useState(false);
//   const [selectedRow, setSelectedRow] = useState();
//   const [startDate1, setStartDate1] = useState(initialStartDate);
//   const [endDate1, setEndDate1] = useState(initialEndDate);
//   const [dateRange1, setDateRange1] = useState(false);
//   const [rowCount, setRowCount] = useState(0);
//   const [states, setStates] = useState([]);
//   const [selectedState, setSelectedState] = useState('');
//   const [selectedSFID, setSelectedSFID] = useState('');
//   const [paginationModel, setPaginationModel] = useState({
//     page: 0,
//     pageSize: 20,
//   });
//   const [searchValue, setSearchValue] = useState('');
//   const [selectedQuarter, setSelectedQuarter] = useState('Q1');

//   const [selectedRowSfids, setSelectedRowSfids] = useState([]);
//   const [selectedRowsMap, setSelectedRowsMap] = useState({});

//   const [selectedOption, setSelectedOption] = useState('agree');
//   const [startDate, setStartDate] = useState();
//   const [dataType, setDataType] = useState(false);
//   const [endDate, setEndDate] = useState();
//   const [data1, setData1] = useState([]);
//   const [selectedDistributorSfid, setSelectedDistributorSfid] = useState('');

//   const [isPaginationEnabled, setIsPaginationEnabled] = useState(true);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [value, setValue] = useState('');
//   const [selectedDownloadStatus, setSelectedDownloadStatus] =
//     useState('Not Downloaded');
//   const [openDialog2, setOpenDialog2] = useState(false);
//   const [imageUrls, setImageUrls] = useState([]);
//   const [imageUrl, setImageUrl] = useState();

//   const [loading, setLoading] = useState(false);

//   const downloadAndZipFiles = async (urls) => {
//     setIsloader(true);
//     const zip = new JSZip();

//     try {
//       // Fetch each file
//       for (const url of urls) {
//         const {
//           file_url__c = '',
//           name,
//           sap_id__c,
//           start_date__c,
//           end_date__c,
//         } = url;
//         const type = file_url__c.split('.').pop();
//         const fileName =
//           name +
//           '_' +
//           start_date__c +
//           '_' +
//           end_date__c +
//           '_' +
//           sap_id__c +
//           '.' +
//           type;
//         const response = await axios.get(file_url__c, {
//           responseType: 'arraybuffer',
//         });

//         // Add file to the zip
//         zip.file(fileName, response.data);
//       }

//       // Generate zip file
//       const content = await zip.generateAsync({ type: 'blob' });

//       setIsloader(false);
//       // Trigger download
//       saveAs(content, 'files.zip');

//       getCategoryData();
//     } catch (error) {
//       console.error('Error downloading files', error);
//     }
//   };

//   const hasItems = Boolean(imageUrl);

//   const isPdf = imageUrl?.toLowerCase().endsWith('.pdf');

//   const onView = async (row) => {
//     try {
//       setIsloader(true);

//       // const dataToExport = [
//       //   {
//       //     start_date__c: row.start_date__c,
//       //     end_date__c: row.end_date__c,
//       //     distributorsfid: row.sfid,
//       //   },
//       // ];

//       // const results = await window.Platform.database.exportBalanceConfirmation({
//       //   distributorDetails: dataToExport,
//       // });

//       const selectedRow = distributorData.find(
//         (item) => item.sap_id__c === row.sap_id__c
//       );
//       setImageUrl(selectedRow.file_url__c);

//       setIsloader(false);
//       setOpenDialog2(true);
//     } catch (err) {
//       setIsloader(false);
//       console.error('error', err);
//       window.NotificationUtils.showError(
//         'Error While Receiving Data. Please try again.'
//       );
//     }
//   };

//   const downloadExcel = (
//     data,
//     filename = 'balance_confirmation_report.xlsx'
//   ) => {
//     const mappedData = data.map((item) => ({
//       State: item.state_name,
//       'Party ID': item.sap_id__c,
//       'Party Name': item.firm_name__c,
//       City: item.city__c,
//       Pincode: item.pincode__c,
//       Mobile: item.mobile__c,
//       'Start Date': item.start_date__c,
//       'End Date': item.end_date__c,
//       Status: item.status,
//     }));

//     const ws = XLSX.utils.json_to_sheet(mappedData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
//     XLSX.writeFile(wb, filename);
//     setIsloader(false);
//   };

//   const exportData = async (type = null) => {
//     try {
//       let selectedRowss = Object.values(selectedRowsMap);

//       if (selectedRowss.length === 0) {
//         selectedRowss = selectedRows;
//       }

//       if (selectedRowss.length === 0) {
//         window.NotificationUtils.showWarning(
//           'Please select checkbox to export data'
//         );
//         return;
//       }

//       setIsloader(true);

//       const dataToExport = selectedRowss.map((row) => ({
//         start_date__c: row.start_date__c,
//         end_date__c: row.end_date__c,
//         distributorsfid: row.sfid,
//       }));

//       if (type === 'excel') {
//         downloadExcel(selectedRowss);
//         return;
//       }

//       const results = await window.Platform.database.exportBalanceConfirmation({
//         distributorDetails: dataToExport,
//       });

//       setSelectedRowSfids([]);
//       setSelectedRowsMap({});
//       setPaginationModel({ page: 0, pageSize: 20 });
//       setSearchValue('');
//       setAgreeDisagree('agree');

//       downloadAndZipFiles(results.data);
//       setIsloader(false);
//     } catch (err) {
//       setIsloader(false);
//       console.error('error', err);
//       window.NotificationUtils.showError(
//         'Error While Receiving Data. Please try again.'
//       );
//     }
//   };

//   const drawerWidth = '240px';
//   // const quarters = {
//   //   Q1: { start: '04-01', end: '06-30' },
//   //   Q2: { start: '04-01', end: '09-30' },
//   //   Q3: { start: '04-01', end: '12-31' },
//   //   Q4: { start: '04-01', end: '03-31' },
//   // };
//   // const handleQuarterChange = (quarter) => {
//   //   if (!quarter) return;
//   //   const currentYear = new Date().getFullYear(); // for now its static but need to implement dynamic
//   //   const selectedQuarter = quarters[quarter];
//   //   setSelectedQuarter(quarter);
//   //   const newStartDate =
//   //     quarter === 'Q4'
//   //       ? dayjs(`${currentYear}-${selectedQuarter.start}`).format('YYYY/MM/DD')
//   //       : dayjs(`${currentYear}-${selectedQuarter.start}`).format('YYYY/MM/DD');
//   //   const newEndDate =
//   //     quarter === 'Q4'
//   //       ? dayjs(`${currentYear + 1}-${selectedQuarter.end}`).format(
//   //           'YYYY/MM/DD'
//   //         )
//   //       : dayjs(`${currentYear}-${selectedQuarter.end}`).format('YYYY/MM/DD');
//   //   setStartDate1(newStartDate);
//   //   setEndDate1(newEndDate);

//   //   return {
//   //     startDate2: newStartDate,
//   //     endDate2: newEndDate,
//   //   };
//   // };

//   const quarters = {
//     Q1: { start: '04-01', end: '06-30' },
//     Q2: { start: '04-01', end: '09-30' },
//     Q3: { start: '04-01', end: '12-31' },
//     Q4: { start: '04-01', end: '03-31' }, // ends next calendar year relative to baseYear
//   };

//   const handleQuarterChange = (quarter) => {
//     if (!quarter) return;

//     // Use previous year until April (Jan–Mar -> previous year; Apr–Dec -> current year)
//     const today = dayjs();
//     const currentYear = today.year();
//     const baseYear = today.month() < 3 ? currentYear - 1 : currentYear;

//     const selectedQuarter = quarters[quarter];
//     setSelectedQuarter(quarter);

//     const startYear = baseYear;
//     const endYear = quarter === 'Q4' ? baseYear + 1 : baseYear;

//     const newStartDate = dayjs(`${startYear}-${selectedQuarter.start}`).format(
//       'YYYY/MM/DD'
//     );
//     const newEndDate = dayjs(`${endYear}-${selectedQuarter.end}`).format(
//       'YYYY/MM/DD'
//     );

//     setStartDate1(newStartDate);
//     setEndDate1(newEndDate);

//     return {
//       startDate2: newStartDate,
//       endDate2: newEndDate,
//     };
//   };

//   const handleStateChange = (e) => {
//     const selectedValue = e.target.value;

//     // Find the selected state object
//     const state = states.find((state) => state.name__c === selectedValue);

//     if (state) {
//       setSelectedState(state.name__c); // Update selected state name
//       setSelectedSFID(state.sfid);
//     }
//   };

//   const handleViewBtn = async (row) => {
//     try {
//       const dataToExport = {
//         start_date__c: row.start_date__c,
//         end_date__c: row.end_date__c,
//         distributorsfid: row.sfid,
//       };

//       const results = await window.Platform.database.exportBalanceConfirmation({
//         distributorDetails: dataToExport,
//       });

//       console.log(results.data);

//       setOpenDialog2(true);
//       setIsloader(false);
//     } catch (err) {
//       setIsloader(false);
//       console.error('error', err);
//       window.NotificationUtils.showError(
//         'Error While Receiving Data. Please try again.'
//       );
//     }
//   };

//   const handleDownloadStatusChange = (e) => {
//     const selectedValue = e.target.value;

//     if (selectedValue) {
//       setSelectedDownloadStatus(selectedValue === 'Downloaded' ? true : false);
//     }
//   };

//   const getCategoryData = async () => {
//     try {
//       let isDownload;
//       if (selectedDownloadStatus === 'Not Downloaded') {
//         isDownload = false;
//       } else if (selectedDownloadStatus === 'Downloaded') {
//         isDownload = true;
//       } else {
//         isDownload = selectedDownloadStatus;
//       }

//       setIsloader(true);
//       const response = await window.Platform.database.getDistributorDetails({
//         searchField: searchValue,
//         pageNumber: paginationModel.page + 1,
//         startDate: startDate1,
//         endDate: endDate1,
//         agree__c: agreeDisagree === 'agree',
//         state__c: selectedSFID,
//         downloaded__c: isDownload,
//       });
//       setIsloader(false);

//       if (response.data) {
//         setDistributorData(response.data.data);
//         setRowCount(response.data.count[0].count);
//       }
//     } catch (error) {
//       setIsloader(false);
//       console.error(error);
//     }
//   };
//   const getStateData = async () => {
//     try {
//       const response = await window.Platform.database.getStates();

//       setStates(response.data.filter((item) => item.name__c));

//       if (!response.hasError) {
//         //setCategoryData([...categoryData, ...response.data]);
//       }
//     } catch (error) {
//       //setIsloader(false);
//       console.error(error);
//     }
//   };

//   const [debouncedQuery, setDebouncedQuery] = useState('');

//   useEffect(() => {
//     console.log('Distributor data updated:', distributorData);
//   }, [distributorData]);
//   useEffect(() => {
//     console.log('selected row ids:', selectedRowIds);
//   }, [selectedRowIds]);
//   useEffect(() => {
//     console.log('states updated', states);
//   }, [states]);
//   useEffect(() => {
//     // getCategoryData();
//     // getStateData();
//   }, [
//     paginationModel.page,
//     searchValue,
//     startDate1,
//     endDate1,
//     agreeDisagree,
//     selectedState,
//   ]);

//   useEffect(() => {
//     getStateData();
//   }, []);

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedQuery(searchValue);
//     }, 1000); // 500ms debounce

//     // Cleanup timeout if query changes before 500ms
//     return () => {
//       clearTimeout(handler);
//     };
//   }, [searchValue]);

//   useEffect(() => {
//     if (debouncedQuery) {
//       getCategoryData();
//     }
//   }, [debouncedQuery]);

//   const handleFilters = () => {
//     setValue('');
//     setIsPaginationEnabled(true);
//     getCategoryData();
//   };

//   const handleSearch = (value) => {
//     setSearchValue(value); // Update state with the entered value
//     console.log('Search Value:', value); // Log or handle the search logic here
//   };

//   const handleColumns = () => {
//     const columns = [
//       // {
//       //   field: "id",
//       //   headerName: "ID",
//       //   width: 100,
//       // },
//       {
//         field: 'state_name',
//         headerName: 'State',
//         width: 150,
//       },
//       {
//         field: 'sap_id__c',
//         headerName: 'Party Id',
//         width: 200,
//       },
//       {
//         field: 'firm_name__c',
//         headerName: 'Party Name',
//         width: 200,
//       },
//       {
//         field: 'city__c',
//         headerName: 'City',
//         width: 150,
//       },
//       {
//         field: 'pincode__c',
//         headerName: 'Pincode',
//         width: 150,
//       },
//       {
//         field: 'mobile__c',
//         headerName: 'Mobile',
//         width: 200,
//       },
//       {
//         field: 'start_date__c',
//         headerName: 'Start Date',
//         width: 200,
//       },
//       {
//         field: 'end_date__c',
//         headerName: 'End date',
//         width: 200,
//       },
//       {
//         field: 'status',
//         headerName: 'Status',
//         width: 200,
//       },

//       {
//         field: 'view',
//         headerName: 'View Documents',
//         width: 150,
//         sortable: false,
//         filterable: false,
//         align: 'center',
//         headerAlign: 'center',
//         renderCell: (params) => (
//           <Tooltip title='Preview'>
//             <IconButton size='small' onClick={() => onView(params.row)}>
//               <VisibilityOutlinedIcon />
//             </IconButton>
//           </Tooltip>
//         ),
//       },
//     ];

//     return columns;
//   };
//   const initialDrawerState = JSON.parse(localStorage.getItem('isDrawerOpen'));

//   // JSON.parse(localStorage.getItem('isDrawerOpen'))

//   const [drawerOpen, setDrawerOpen] = useState(
//     isMobile ? false : initialDrawerState
//   );

//   const rows = distributorData.map((item, index) => ({
//     id: item.sfid,
//     state_name: item.state_name,
//     sap_id__c: item.sap_id__c,
//     sfid: item.sfid,
//     city__c: item.city__c,
//     pincode__c: item.pincode__c,
//     firm_name__c: item.firm_name__c,
//     mobile__c: item.mobile__c,
//     start_date__c: item.start_date__c,
//     end_date__c: item.end_date__c,
//     status: item.downloaded__c ? 'Downloaded' : 'Not Downloaded',
//   }));
//   useEffect(() => {
//     localStorage.setItem('isDrawerOpen', drawerOpen);
//   }, [drawerOpen]);

//   // const clearDateFilter = async () => {
//   //   setSearchValue('');
//   //   setSelectedState('');
//   //   setSelectedSFID('');
//   //   setSelectedQuarter('Q1');
//   //   handleQuarterChange('Q1');
//   //   setIsPaginationEnabled(true);
//   //   setValue('');
//   //   setSelectedRowSfids([]);
//   //   setSelectedRowsMap({});
//   //   setSelectedRowIds([]);
//   //   setSelectedRows([]);
//   //   setSelectedDownloadStatus('Not Downloaded');

//   //   getCategoryData();
//   // };

//   // Option 1: Pass the next values directly to getCategoryData (recommended)
//   const clearDateFilter = () => {
//     const next = {
//       searchValue: '',
//       selectedState: '',
//       selectedSFID: '',
//       selectedQuarter: 'Q1',
//       isPaginationEnabled: true,
//       value: '',
//       selectedRowSfids: [],
//       selectedRowsMap: {},
//       selectedRowIds: [],
//       selectedRows: [],
//       selectedDownloadStatus: 'Not Downloaded',
//     };

//     setSearchValue(next.searchValue);
//     setSelectedState(next.selectedState);
//     setSelectedSFID(next.selectedSFID);
//     setSelectedQuarter(next.selectedQuarter);
//     handleQuarterChange(next.selectedQuarter);
//     setIsPaginationEnabled(next.isPaginationEnabled);
//     setValue(next.value);
//     setSelectedRowSfids(next.selectedRowSfids);
//     setSelectedRowsMap(next.selectedRowsMap);
//     setSelectedRowIds(next.selectedRowIds);
//     setSelectedRows(next.selectedRows);
//     setSelectedDownloadStatus(next.selectedDownloadStatus);

//     getCategoryData1(next);
//   };

//   // getCategoryData should read from params, not state
//   const getCategoryData1 = async (params = {}) => {
//     const {
//       searchValue,
//       selectedState,
//       selectedSFID,
//       selectedQuarter,
//       isPaginationEnabled,
//       value,
//       selectedRowSfids,
//       selectedRowsMap,
//       selectedRowIds,
//       selectedRows,
//       selectedDownloadStatus,
//     } = params;

//     try {
//       let isDownload;
//       if (selectedDownloadStatus === 'Not Downloaded') {
//         isDownload = false;
//       } else if (selectedDownloadStatus === 'Downloaded') {
//         isDownload = true;
//       } else {
//         isDownload = selectedDownloadStatus;
//       }

//       const { startDate2, endDate2 } = handleQuarterChange('Q1');

//       setIsloader(true);
//       const response = await window.Platform.database.getDistributorDetails({
//         searchField: '',
//         pageNumber: 1,
//         startDate: startDate2,
//         endDate: endDate2,
//         agree__c: agreeDisagree === 'agree',
//         state__c: '',
//         downloaded__c: false,
//       });
//       setIsloader(false);

//       if (response.data) {
//         setDistributorData(response.data.data);
//         setRowCount(response.data.count[0].count);
//       }
//     } catch (error) {
//       setIsloader(false);
//       console.error(error);
//     }
//   };

//   const handleRadioChange = async (event) => {
//     const value = event.target.value;
//     setValue((prev) => (prev === value ? '' : value));
//     setIsPaginationEnabled(false);
//     setSelectedOption(value);
//     setLoading(true);
//     setDataType(true);
//     setSelectedRowIds([]);

//     let isDownload;
//     if (selectedDownloadStatus === 'Not Downloaded') {
//       isDownload = false;
//     } else if (selectedDownloadStatus === 'Downloaded') {
//       isDownload = true;
//     } else {
//       isDownload = selectedDownloadStatus;
//     }

//     const response = await window.Platform.database.getDistributorDetails({
//       searchField: searchValue,
//       pageNumber: paginationModel.page + 1,
//       startDate: startDate1,
//       endDate: endDate1,
//       agree__c: agreeDisagree === 'agree',
//       state__c: selectedSFID,
//       dataType: true,
//       downloaded__c: isDownload,
//     });
//     setIsloader(false);
//     if (response.data) {
//       setDistributorData(response.data.data);
//       setDistributorData1(
//         response.data.data.map((item, index) => ({
//           id: index,
//           state_name: item.state_name,
//           sap_id__c: item.sap_id__c,
//           sfid: item.sfid,
//           city__c: item.city__c,
//           pincode__c: item.pincode__c,
//           firm_name__c: item.firm_name__c,
//           mobile__c: item.mobile__c,
//           start_date__c: item.start_date__c,
//           end_date__c: item.end_date__c,
//           status: item.downloaded__c ? 'Downloaded' : 'Not Downloaded',
//         }))
//       );
//       setRowCount(response.data.count[0].count);
//     }
//     setLoading(false);
//   };

//   return (
//     <div
//       style={{
//         display: 'flex',
//         width: '100%',
//         backgroundColor: '#F6F6F6',
//         minHeight: '100vh',
//       }}
//     >
//       <Sidebar />
//       <Container>
//         {loading && <OpaqueLoading />}
//         <CustomHeader name='financial-report' />
//         <Box sx={{ px: 3 }}>
//           <Box>
//             <Card sx={{ padding: '20px', borderRadius: '10px', marginTop: 2 }}>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm={6} md={4}>
//                   <TextField
//                     fullWidth
//                     placeholder='Search...'
//                     value={searchValue}
//                     onChange={(e) => handleSearch(e.target.value)}
//                     size='medium'
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6} md={4}>
//                   <FormControl fullWidth>
//                     <Select
//                       displayEmpty
//                       value={selectedDownloadStatus}
//                       onChange={(e) => handleDownloadStatusChange(e)}
//                       renderValue={(selected) => {
//                         if (typeof selected === 'boolean') {
//                           return selected ? 'Downloaded' : 'Not Downloaded';
//                         } else {
//                           return selected;
//                         }
//                       }}
//                     >
//                       {['Downloaded', 'Not Downloaded'].map((status) => (
//                         <MenuItem key={status} value={status}>
//                           {status}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   <FormControl fullWidth>
//                     <Select
//                       displayEmpty
//                       value={selectedState}
//                       onChange={(e) => handleStateChange(e)}
//                       renderValue={(selected) =>
//                         selected ? selected : 'Select State'
//                       }
//                     >
//                       <MenuItem value='' disabled>
//                         Select State
//                       </MenuItem>
//                       {states.map((state) => (
//                         <MenuItem key={state.sfid} value={state.name__c}>
//                           {state.name__c}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   <FormControl fullWidth>
//                     <Select
//                       value={selectedQuarter}
//                       onChange={(e) => handleQuarterChange(e.target.value)}
//                     >
//                       <MenuItem value='Q1'>Quarter 1 (April to June)</MenuItem>
//                       <MenuItem value='Q2'>
//                         Quarter 2 (July to September)
//                       </MenuItem>
//                       <MenuItem value='Q3'>
//                         Quarter 3 (October to December)
//                       </MenuItem>
//                       <MenuItem value='Q4'>
//                         Quarter 4 (January to March)
//                       </MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   <TextField
//                     fullWidth
//                     value={startDate1 || ''}
//                     placeholder='Start Date'
//                     disabled
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   <TextField
//                     fullWidth
//                     value={endDate1 || ''}
//                     placeholder='End Date'
//                     disabled
//                     InputProps={{ readOnly: true }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   <FormControl
//                     component='fieldset'
//                     sx={{
//                       borderRadius: '40px',
//                       padding: '5px 10px',
//                       width: '100%',
//                     }}
//                   >
//                     <RadioGroup row value={value} onChange={handleRadioChange}>
//                       <FormControlLabel
//                         value='all'
//                         control={
//                           <Radio value='all' sx={{ color: '#85c225' }} />
//                         }
//                         label='Get all records'
//                         labelPlacement='end'
//                         sx={{
//                           '& .MuiFormControlLabel-label': {
//                             color: '#85c225',
//                             textAlign: 'left',
//                             whiteSpace: 'nowrap',
//                           },
//                         }}
//                         disabled={!selectedState}
//                       />
//                     </RadioGroup>
//                   </FormControl>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   <Button
//                     // startIcon={<GetAppIcon />}
//                     size='large'
//                     variant='contained'
//                     onClick={() => handleFilters()}
//                     sx={{ height: 50 }}
//                     fullWidth
//                   >
//                     Apply Filters
//                   </Button>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   {isloader && <OpaqueLoading />}
//                   <Button
//                     startIcon={<GetAppIcon />}
//                     size='large'
//                     variant='contained'
//                     onClick={() => exportData()}
//                     sx={{ height: 50 }}
//                     fullWidth
//                     disabled={!startDate && !endDate && !selectedState}
//                   >
//                     Download documents
//                   </Button>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   <Button
//                     startIcon={<GetAppIcon />}
//                     size='large'
//                     variant='contained'
//                     onClick={() => exportData('excel')}
//                     sx={{ height: 50 }}
//                     fullWidth
//                     disabled={!startDate && !endDate && !selectedState}
//                   >
//                     Export excel
//                   </Button>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                   <Box
//                     display='flex'
//                     flexDirection='row-reverse'
//                     alignItems='center'
//                     justifyContent='flex-end'
//                     gap={1}
//                   >
//                     <Typography
//                       variant='subtitle2'
//                       sx={{
//                         fontWeight: 500,
//                         color: '#85c225',
//                       }}
//                     >
//                       Refresh Data
//                     </Typography>

//                     <IconButton
//                       size='large'
//                       disabled={(!selectedState && !searchValue) || isloader}
//                       onClick={() => clearDateFilter()}
//                       sx={{ alignSelf: 'flex-start' }}
//                     >
//                       <RefreshIcon fontSize='large' />
//                     </IconButton>
//                   </Box>
//                 </Grid>
//               </Grid>

//               <br />

//               {/* <div>
//                 <div
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     flexDirection: 'row',
//                     gap: '20px',
//                     paddingTop: '4px',
//                     marginBottom: '10px',
//                   }}
//                 >
//                   <input
//                     type='text'
//                     placeholder='Search...'
//                     style={{
//                       flex: '1',
//                       padding: '8px',
//                       fontSize: '16px',
//                       border: '1px solid #ccc',
//                       borderRadius: '4px',
//                     }}
//                     value={searchValue}
//                     onChange={(e) => handleSearch(e.target.value)}
//                   />
//                   <select
//                     style={{
//                       padding: '8px',
//                       fontSize: '16px',
//                       border: '1px solid #ccc',
//                       borderRadius: '4px',
//                       background: '#fff',
//                     }}
//                     value={selectedState}
//                     onChange={(e) => handleStateChange(e)}
//                   >
//                     <option value='' disabled selected>
//                       Select State
//                     </option>
//                     {states.map((state) => (
//                       <option key={state.sfid} value={state.name__c}>
//                         {state.name__c}
//                       </option>
//                     ))}
//                   </select>
//                   <IconButton
//                     size='large'
//                     variant='contained'
//                     disabled={(!selectedState && !searchValue) || isloader}
//                     onClick={() => clearDateFilter()}
//                   >
//                     <RefreshIcon fontSize='large' />
//                   </IconButton>
//                   {isloader && <OpaqueLoading />}
//                   <Button
//                     startIcon={<GetAppIcon />}
//                     size='large'
//                     style={{
//                       height: '50px',
//                       padding: '8px 16px',
//                       fontSize: '16px',
//                       borderRadius: '4px',
//                     }}
//                     onClick={() => exportData()}
//                     variant='contained'
//                   >
//                     Download
//                   </Button>
//                   <Button
//                     startIcon={<GetAppIcon />}
//                     size='large'
//                     style={{
//                       height: '50px',
//                       padding: '8px 16px',
//                       fontSize: '16px',
//                       borderRadius: '4px',
//                     }}
//                     onClick={() => exportData()}
//                     variant='contained'
//                   >
//                     Export
//                   </Button>
//                 </div>
//               </div>
//               <div>
//                 <div
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     flexDirection: 'row',
//                     gap: '20px',
//                     marginBottom: '10px',
//                   }}
//                 >
//                   <select
//                     style={{
//                       flex: '1',
//                       padding: '8px',
//                       fontSize: '16px',
//                       border: '1px solid #ccc',
//                       borderRadius: '4px',
//                     }}
//                     value={selectedQuarter}
//                     onChange={(e) => handleQuarterChange(e.target.value)}
//                   >
//                     <option value='Q1'>Quarter 1 (April to June)</option>
//                     <option value='Q2'>Quarter 2 (July to September)</option>
//                     <option value='Q3'>Quarter 3 (October to December)</option>
//                     <option value='Q4'>Quarter 4 (January to March)</option>
//                   </select>
//                   <input
//                     type='text'
//                     value={startDate1 || ''}
//                     placeholder='Start Date'
//                     style={{
//                       padding: '8px',
//                       fontSize: '16px',
//                       border: '1px solid #ccc',
//                       borderRadius: '4px',
//                       backgroundColor: '#f5f5f5',
//                     }}
//                     disabled
//                   />
//                   <input
//                     type='text'
//                     value={endDate1 || ''}
//                     placeholder='End Date'
//                     style={{
//                       padding: '8px',
//                       fontSize: '16px',
//                       border: '1px solid #ccc',
//                       borderRadius: '4px',
//                       backgroundColor: '#f5f5f5',
//                     }}
//                     disabled
//                   />

//                   <FormControl
//                     component='fieldset'
//                     sx={{
//                       borderRadius: '40px',
//                       padding: '5px 10px',
//                       flexGrow: 1,
//                       flexBasis: 0,
//                       minWidth: 0,
//                     }}
//                   >
//                     <RadioGroup row onChange={handleRadioChange}>
//                       <FormControlLabel
//                         value='all'
//                         control={<Radio sx={{ color: '#85c225' }} />}
//                         label='Get all record for selected date'
//                         labelPlacement='end'
//                         sx={{
//                           '& .MuiFormControlLabel-label': {
//                             color: '#85c225',
//                             textAlign: 'left',
//                             whiteSpace: 'nowrap',
//                           },
//                         }}
//                       />
//                     </RadioGroup>
//                   </FormControl>
//                 </div>
//               </div> */}

//               {view === 0 && (
//                 <DataGridContainer
//                   style={{ height: rows.length > 0 ? '400px' : '300px' }}
//                 >
//                   {isPaginationEnabled ? (
//                     <DataGrid
//                       rows={rows}
//                       columns={handleColumns()}
//                       checkboxSelection
//                       // onRowClick={(params) => {
//                       //   console.log("RowClick", params);
//                       //   setSelectedRow(params.row);
//                       //   setView(1);
//                       // }}
//                       rowSelectionModel={selectedRowSfids}
//                       // onRowSelectionModelChange={(selectedRowIndices) => {
//                       //   console.log('Selected Row Indices:', selectedRowIndices);
//                       //   setSelectedRowIds(selectedRowIndices);
//                       // }}
//                       onRowSelectionModelChange={(newSelection) => {
//                         setSelectedRowSfids((prev) => {
//                           const currentPageSfids = rows.map((r) => r.sfid);
//                           const removed = prev.filter(
//                             (sfid) => !currentPageSfids.includes(sfid)
//                           );
//                           const added = newSelection.filter(
//                             (sfid) => !removed.includes(sfid)
//                           );
//                           setSelectedRowsMap((prevMap) => {
//                             const updatedMap = { ...prevMap };
//                             currentPageSfids.forEach((sfid) => {
//                               if (!newSelection.includes(sfid)) {
//                                 delete updatedMap[sfid];
//                               }
//                             });
//                             rows.forEach((row) => {
//                               if (newSelection.includes(row.sfid)) {
//                                 updatedMap[row.sfid] = row;
//                               }
//                             });
//                             return updatedMap;
//                           });
//                           return [...removed, ...added];
//                         });
//                       }}
//                       disableSelectionOnClick
//                       disableRowSelectionOnClick
//                       paginationModel={paginationModel}
//                       paginationMode='server'
//                       onPaginationModelChange={setPaginationModel}
//                       rowCount={rowCount}
//                       components={{
//                         Toolbar: CustomToolbar,
//                       }}
//                       componentsProps={{
//                         toolbar: {
//                           onAgreeDisagree: setAgreeDisagree,
//                         },
//                       }}
//                     />
//                   ) : (
//                     <DataGrid
//                       // data
//                       rows={distributorData1}
//                       columns={handleColumns()}
//                       // selection
//                       checkboxSelection
//                       getRowId={(row) => row.id} // <-- use sfid as the unique id
//                       disableRowSelectionExcludeModel // <-- predictable include-only selection model
//                       rowSelectionModel={selectedRowIds}
//                       onRowSelectionModelChange={(newSelection) => {
//                         // ✅ simplest: just save what the grid sends

//                         // 1) Save IDs
//                         setSelectedRowIds(newSelection);

//                         // 2) Save OBJECTS (filter rows by selected ids)
//                         const idSet = new Set(newSelection);
//                         const selectedObjects = distributorData1.filter((r) =>
//                           idSet.has(r.id)
//                         );
//                         setSelectedRows(selectedObjects);

//                         // 3) Optional: map keyed by id for O(1) lookup
//                         setSelectedRowsMap(
//                           Object.fromEntries(
//                             selectedObjects.map((r) => [r.id, r])
//                           )
//                         );

//                         // (optional) keep a map of selected rows for quick access
//                         // setSelectedRowsMap((prev) => {
//                         //   const next = { ...prev };
//                         //   // Clear map for current page first
//                         //   for (const r of distributorData1) delete next[r.sfid];
//                         //   // Add selected from current page
//                         //   for (const r of distributorData1) {
//                         //     if (newSelection.includes(r.sfid)) next[r.sfid] = r;
//                         //   }
//                         //   return next;
//                         // });
//                       }}
//                       disableSelectionOnClick
//                       disableRowSelectionOnClick
//                       // pagination (client-side)
//                       paginationModel={paginationModel}
//                       paginationMode='server'
//                       onPaginationModelChange={setPaginationModel}
//                       // If you want to hide the footer controls while still paginating, keep this:
//                       hideFooterPagination
//                       // In client mode, rowCount is not used; you can remove it or leave it harmlessly.
//                       // rowCount={rowCount}

//                       // toolbar
//                       components={{
//                         Toolbar: CustomToolbar,
//                       }}
//                       componentsProps={{
//                         toolbar: {
//                           onAgreeDisagree: setAgreeDisagree,
//                         },
//                       }}
//                     />
//                   )}
//                 </DataGridContainer>
//               )}
//             </Card>
//           </Box>
//         </Box>
//       </Container>

//       {/* <Dialog
//         open={openDialog2}
//         onClose={() => {
//           setOpenDialog2(false);
//           getCategoryData();
//         }}
//         maxWidth='md'
//         fullWidth
//       >
//         <DialogTitle>
//           Preview
//           {/* {hasItems && (
//             <Stack direction='row' spacing={1} sx={{ float: 'right' }}>
//               <Tooltip title='Open in new tab'>
//                 <IconButton
//                   onClick={() => openInNewTab(currentUrl.file_url__c)}
//                   size='small'
//                 >
//                   <OpenInNewIcon />
//                 </IconButton>
//               </Tooltip>
//               <Tooltip title='Previous'>
//                 <span>
//                   <IconButton onClick={prev} size='small' disabled={!hasItems}>
//                     <ArrowBackIosNewIcon />
//                   </IconButton>
//                 </span>
//               </Tooltip>
//               <Tooltip title='Next'>
//                 <span>
//                   <IconButton onClick={next} size='small' disabled={!hasItems}>
//                     <ArrowForwardIosIcon />
//                   </IconButton>
//                 </span>
//               </Tooltip>
//             </Stack>
//           )} */}
//       {/* </DialogTitle>

//         <DialogContent dividers> */}
//       {/* {!hasItems ? (
//             <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
//               No files to preview
//             </Box>
//           ) :  */}
//       {/* {isPdf ? (
//             <PdfIframe url={currentUrl?.file_url__c} />
//           ) : (
//             <Box sx={{ textAlign: 'center' }}>
//               <img
//                 src={currentUrl.file_url__c}
//                 alt={`Preview`}
//                 style={{
//                   maxWidth: '100%',
//                   maxHeight: '80vh',
//                   display: 'inline-block',
//                 }}
//                 onClick={() => openInNewTab(currentUrl.file_url__c)}
//               />
//             </Box>
//           )} */}

//       {/* Thumbnails / quick navigation (optional) */}
//       {/* {hasItems && (
//             <Stack
//               direction='row'
//               spacing={1}
//               sx={{
//                 mt: 2,
//                 overflowX: 'auto',
//                 alignItems: 'center',
//                 pb: 1,
//               }}
//             >
//               {imageUrls.map((u, i) => {
//                 const pdf = u.file_url__c.toLowerCase().endsWith('.pdf');
//                 return (
//                   <Box
//                     key={`${i}-${u.file_url__c}`}
//                     onClick={() => setIndex(i)}
//                     sx={{
//                       border:
//                         i === index ? '2px solid #1976d2' : '1px solid #ddd',
//                       borderRadius: 1,
//                       p: 0.5,
//                       cursor: 'pointer',
//                       flex: '0 0 auto',
//                     }}
//                   >
//                     {pdf ? (
//                       <Box
//                         sx={{
//                           width: 90,
//                           height: 60,
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           bgcolor: '#f5f5f5',
//                           color: '#d32f2f',
//                           fontSize: 12,
//                           fontWeight: 600,
//                         }}
//                       >
//                         PDF
//                       </Box>
//                     ) : (
//                       <img
//                         src={u.file_url__c}
//                         alt={`thumb-${i}`}
//                         style={{ width: 90, height: 60, objectFit: 'cover' }}
//                         loading='lazy'
//                       />
//                     )}
//                   </Box>
//                 );
//               })}
//             </Stack>
//           )} */}
//       {/* </DialogContent> */}
//       {/*</Dialog> */}

//       <Dialog
//         open={openDialog2}
//         onClose={() => {
//           setOpenDialog2(false);
//           // getCategoryData();
//         }}
//         maxWidth='md'
//         fullWidth
//         onContextMenu={(e) => e.preventDefault()}
//       >
//         <DialogTitle>
//           Preview
//           {/* {hasItems && (
//             <Stack direction='row' spacing={1} sx={{ float: 'right' }}>
//               <Tooltip title='Open in new tab'>
//                 <IconButton
//                   size='small'
//                   onClick={() => openInNewTab(imageUrl.file_url__c)}
//                 >
//                   <OpenInNewIcon />
//                 </IconButton>
//               </Tooltip>
//             </Stack>
//           )} */}
//         </DialogTitle>

//         <DialogContent dividers>
//           {/* {!hasItems ? (
//             <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
//               No files to preview
//             </Box> */}
//           {/* ) :  */}
//           {isPdf ? (
//             <PdfIframe url={imageUrl} />
//           ) : (
//             <Box sx={{ textAlign: 'center' }}>
//               <img
//                 src={imageUrl}
//                 alt='Preview'
//                 style={{
//                   maxWidth: '100%',
//                   maxHeight: '80vh',
//                   // cursor: 'pointer',
//                 }}
//                 // onClick={() => openInNewTab(imageUrl)}
//               />
//             </Box>
//           )}
//         </DialogContent>
//       </Dialog>
//     </div>
//   );
// };

// export default FinanceManagement;
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import styled from '@emotion/styled';
import { DataGrid } from '@mui/x-data-grid';
import { GridToolbarContainer } from '@mui/x-data-grid';
import OpaqueLoading from '../../components/opaqueLoading/opaqueLoading';
import {
  IconButton,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
  Grid,
  TextField,
  Select,
  MenuItem,
  Button,
  Card,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';

import { Stack, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import RefreshIcon from '@mui/icons-material/Refresh';
import GetAppIcon from '@mui/icons-material/GetApp';
import * as XLSX from 'xlsx';

import Sidebar from '../../components/common/sidebar/Sidebar';
import CustomHeader from '../../components/common/header/CustomHeader';

const isMobile = window.innerWidth < 900;

const Container = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const DataGridContainer = styled.div`
  width: 100%;
  && .highlighted-row {
    background-color: #ffcccb !important;
  }
`;

function PdfIframe({ url }) {
  console.log('url', url);
  const [blobUrl, setBlobUrl] = React.useState(null);

  React.useEffect(() => {
    let revoke;
    (async () => {
      const res = await fetch(url, {
        /* credentials/headers if needed */
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const objUrl = URL.createObjectURL(
        new Blob([blob], { type: 'application/pdf' })
      );
      revoke = objUrl;
      setBlobUrl(objUrl);
    })();
    return () => revoke && URL.revokeObjectURL(revoke);
  }, [url]);

  return blobUrl ? (
    <iframe
      src={blobUrl}
      style={{ width: '100%', height: '80vh', border: 'none' }}
      title='PDF'
    />
  ) : (
    <div>Loading…</div>
  );
}

const CustomToolbar = ({ onAgreeDisagree }) => {
  const [selectedOption, setSelectedOption] = useState('agree');
  const handleRadioChange = (event) => {
    const value = event.target.value;
    onAgreeDisagree(value);
    setSelectedOption(value);
  };

  return (
    <GridToolbarContainer>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <FormControl
          component='fieldset'
          sx={{
            display: 'flex',
            flexDirection: 'row',
            borderRadius: '40px',
            padding: '5px 10px',
          }}
        >
          <RadioGroup row value={selectedOption} onChange={handleRadioChange}>
            <FormControlLabel
              value='agree'
              control={<Radio sx={{ color: '#85c225' }} />}
              label='Agree'
              labelPlacement='end'
              sx={{ '& .MuiFormControlLabel-label': { color: '#85c225' } }}
            />
            <FormControlLabel
              value='disagree'
              control={<Radio sx={{ color: '#85c225' }} />}
              label='Disagree'
              labelPlacement='end'
              sx={{ '& .MuiFormControlLabel-label': { color: '#85c225' } }}
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </GridToolbarContainer>
  );
};

const quarters = {
  Q1: { start: '04-01', end: '06-30' },
  Q2: { start: '04-01', end: '09-30' },
  Q3: { start: '04-01', end: '12-31' },
  Q4: { start: '04-01', end: '03-31' },
};
// const currentYear = new Date().getFullYear(); // as of now its static but need to implement dyanamic
// const initialStartDate =
//   quarters.Q1.start &&
//   dayjs(`${currentYear}-${quarters.Q1.start}`).format('YYYY/MM/DD');
// const initialEndDate =
//   quarters.Q1.end &&
//   dayjs(`${currentYear}-${quarters.Q1.end}`).format('YYYY/MM/DD');

// Base year: use previous year until April arrives
const today = dayjs();
const currentYear = today.year();
const baseYear = today.month() < 3 ? currentYear - 1 : currentYear;

// For Q1 initial range
const initialStartDate =
  quarters.Q1.start &&
  dayjs(`${baseYear}-${quarters.Q1.start}`).format('YYYY/MM/DD');

const initialEndDate =
  quarters.Q1.end &&
  dayjs(`${baseYear}-${quarters.Q1.end}`).format('YYYY/MM/DD');

const FinanceManagement = () => {
  const [agreeDisagree, setAgreeDisagree] = useState('agree');
  const [isloader, setIsloader] = React.useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [distributorData, setDistributorData] = useState([]);
  const [distributorData1, setDistributorData1] = useState([]);
  const [view, setView] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [startDate1, setStartDate1] = useState(initialStartDate);
  const [endDate1, setEndDate1] = useState(initialEndDate);
  const [dateRange1, setDateRange1] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedSFID, setSelectedSFID] = useState('');
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const [searchValue, setSearchValue] = useState('');
  const [selectedQuarter, setSelectedQuarter] = useState('Q1');

  const [selectedRowSfids, setSelectedRowSfids] = useState([]);
  const [selectedRowsMap, setSelectedRowsMap] = useState({});

  const [selectedOption, setSelectedOption] = useState('agree');
  const [startDate, setStartDate] = useState();
  const [dataType, setDataType] = useState(false);
  const [endDate, setEndDate] = useState();
  const [data1, setData1] = useState([]);
  const [selectedDistributorSfid, setSelectedDistributorSfid] = useState('');

  const [isPaginationEnabled, setIsPaginationEnabled] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [value, setValue] = useState('');
  const [selectedDownloadStatus, setSelectedDownloadStatus] =
    useState('Not Downloaded');
  const [openDialog2, setOpenDialog2] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [imageUrl, setImageUrl] = useState();

  const [loading, setLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);



  const downloadAndZipFiles = async (urls) => {
    setIsloader(true);
    const zip = new JSZip();

    try {
      // Fetch each file
      for (const url of urls) {
        const {
          file_url__c = '',
          name,
          sap_id__c,
          start_date__c,
          end_date__c,
        } = url;
        const type = file_url__c.split('.').pop();
        const fileName =
          name +
          '_' +
          start_date__c +
          '_' +
          end_date__c +
          '_' +
          sap_id__c +
          '.' +
          type;
        const response = await axios.get(file_url__c, {
          responseType: 'arraybuffer',
        });

        // Add file to the zip
        zip.file(fileName, response.data);
      }

      // Generate zip file
      const content = await zip.generateAsync({ type: 'blob' });

      setIsloader(false);
      // Trigger download
      saveAs(content, 'files.zip');

      getCategoryData();
    } catch (error) {
      console.error('Error downloading files', error);
    }
  };

  const hasItems = Boolean(imageUrl);

  const isPdf = imageUrl?.toLowerCase().endsWith('.pdf');

  const onView = async (row) => {
    try {
      setIsloader(true);

      // const dataToExport = [
      //   {
      //     start_date__c: row.start_date__c,
      //     end_date__c: row.end_date__c,
      //     distributorsfid: row.sfid,
      //   },
      // ];

      // const results = await window.Platform.database.exportBalanceConfirmation({
      //   distributorDetails: dataToExport,
      // });

      const selectedRow = distributorData.find(
        (item) => item.sap_id__c === row.sap_id__c
      );
      setImageUrl(selectedRow.file_url__c);

      setIsloader(false);
      setOpenDialog2(true);
    } catch (err) {
      setIsloader(false);
      console.error('error', err);
      window.NotificationUtils.showError(
        'Error While Receiving Data. Please try again.'
      );
    }
  };

  const downloadExcel = (
    data,
    filename = 'balance_confirmation_report.xlsx'
  ) => {
    const mappedData = data.map((item) => ({
      State: item.state_name,
      'Party ID': item.sap_id__c,
      'Party Name': item.firm_name__c,
      City: item.city__c,
      Pincode: item.pincode__c,
      Mobile: item.mobile__c,
      'Start Date': item.start_date__c,
      'End Date': item.end_date__c,
      Status: item.status,
    }));

    const ws = XLSX.utils.json_to_sheet(mappedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename);
    setIsloader(false);
  };

  const exportData = async (type = null) => {
    try {
      let selectedRowss = Object.values(selectedRowsMap);

      if (selectedRowss.length === 0) {
        selectedRowss = selectedRows;
      }

      if (selectedRowss.length === 0) {
        window.NotificationUtils.showWarning(
          'Please select checkbox to export data'
        );
        return;
      }

      setIsloader(true);

      const dataToExport = selectedRowss.map((row) => ({
        start_date__c: row.start_date__c,
        end_date__c: row.end_date__c,
        distributorsfid: row.sfid,
      }));

      if (type === 'excel') {
        downloadExcel(selectedRowss);
        return;
      }

      const results = await window.Platform.database.exportBalanceConfirmation({
        distributorDetails: dataToExport,
      });

      setSelectedRowSfids([]);
      setSelectedRowsMap({});
      setPaginationModel({ page: 0, pageSize: 20 });
      setSearchValue('');
      setAgreeDisagree('agree');

      downloadAndZipFiles(results.data);
      setIsloader(false);
    } catch (err) {
      setIsloader(false);
      console.error('error', err);
      window.NotificationUtils.showError(
        'Error While Receiving Data. Please try again.'
      );
    }
  };

  const drawerWidth = '240px';
  // const quarters = {
  //   Q1: { start: '04-01', end: '06-30' },
  //   Q2: { start: '04-01', end: '09-30' },
  //   Q3: { start: '04-01', end: '12-31' },
  //   Q4: { start: '04-01', end: '03-31' },
  // };
  // const handleQuarterChange = (quarter) => {
  //   if (!quarter) return;
  //   const currentYear = new Date().getFullYear(); // for now its static but need to implement dynamic
  //   const selectedQuarter = quarters[quarter];
  //   setSelectedQuarter(quarter);
  //   const newStartDate =
  //     quarter === 'Q4'
  //       ? dayjs(`${currentYear}-${selectedQuarter.start}`).format('YYYY/MM/DD')
  //       : dayjs(`${currentYear}-${selectedQuarter.start}`).format('YYYY/MM/DD');
  //   const newEndDate =
  //     quarter === 'Q4'
  //       ? dayjs(`${currentYear + 1}-${selectedQuarter.end}`).format(
  //           'YYYY/MM/DD'
  //         )
  //       : dayjs(`${currentYear}-${selectedQuarter.end}`).format('YYYY/MM/DD');
  //   setStartDate1(newStartDate);
  //   setEndDate1(newEndDate);

  //   return {
  //     startDate2: newStartDate,
  //     endDate2: newEndDate,
  //   };
  // };

  const quarters = {
    Q1: { start: '04-01', end: '06-30' },
    Q2: { start: '04-01', end: '09-30' },
    Q3: { start: '04-01', end: '12-31' },
    Q4: { start: '04-01', end: '03-31' }, // ends next calendar year relative to baseYear
  };

const handleQuarterChange = (quarter, year = selectedYear) => {
  if (!quarter) return;

  const selectedQuarter = quarters[quarter];
  setSelectedQuarter(quarter);

  const startYear = year;
  const endYear = quarter === 'Q4' ? year + 1 : year;

  const newStartDate = dayjs(`${startYear}-${selectedQuarter.start}`).format(
    'YYYY/MM/DD'
  );
  const newEndDate = dayjs(`${endYear}-${selectedQuarter.end}`).format(
    'YYYY/MM/DD'
  );

  setStartDate1(newStartDate);
  setEndDate1(newEndDate);

  return {
    startDate2: newStartDate,
    endDate2: newEndDate,
  };
};

  const handleStateChange = (e) => {
    const selectedValue = e.target.value;

    // Find the selected state object
    const state = states.find((state) => state.name__c === selectedValue);

    if (state) {
      setSelectedState(state.name__c); // Update selected state name
      setSelectedSFID(state.sfid);
    }
  };

  const handleViewBtn = async (row) => {
    try {
      const dataToExport = {
        start_date__c: row.start_date__c,
        end_date__c: row.end_date__c,
        distributorsfid: row.sfid,
      };

      const results = await window.Platform.database.exportBalanceConfirmation({
        distributorDetails: dataToExport,
      });

      console.log(results.data);

      setOpenDialog2(true);
      setIsloader(false);
    } catch (err) {
      setIsloader(false);
      console.error('error', err);
      window.NotificationUtils.showError(
        'Error While Receiving Data. Please try again.'
      );
    }
  };

  const handleDownloadStatusChange = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue) {
      setSelectedDownloadStatus(selectedValue === 'Downloaded' ? true : false);
    }
  };

  const getCategoryData = async () => {
    try {
      let isDownload;
      if (selectedDownloadStatus === 'Not Downloaded') {
        isDownload = false;
      } else if (selectedDownloadStatus === 'Downloaded') {
        isDownload = true;
      } else {
        isDownload = selectedDownloadStatus;
      }

      setIsloader(true);
      const response = await window.Platform.database.getDistributorDetails({
        searchField: searchValue,
        pageNumber: paginationModel.page + 1,
        startDate: startDate1,
        endDate: endDate1,
        agree__c: agreeDisagree === 'agree',
        state__c: selectedSFID,
        downloaded__c: isDownload,
      });
      setIsloader(false);

      if (response.data) {
        setDistributorData(response.data.data);
        setRowCount(response.data.count[0].count);
      }
    } catch (error) {
      setIsloader(false);
      console.error(error);
    }
  };
  const getStateData = async () => {
    try {
      const response = await window.Platform.database.getStates();

      setStates(response.data.filter((item) => item.name__c));

      if (!response.hasError) {
        //setCategoryData([...categoryData, ...response.data]);
      }
    } catch (error) {
      //setIsloader(false);
      console.error(error);
    }
  };

  const [debouncedQuery, setDebouncedQuery] = useState('');

  useEffect(() => {
    console.log('Distributor data updated:', distributorData);
  }, [distributorData]);
  useEffect(() => {
    console.log('selected row ids:', selectedRowIds);
  }, [selectedRowIds]);
  useEffect(() => {
    console.log('states updated', states);
  }, [states]);
  useEffect(() => {
    // getCategoryData();
    // getStateData();
  }, [
    paginationModel.page,
    searchValue,
    startDate1,
    endDate1,
    agreeDisagree,
    selectedState,
  ]);

  useEffect(() => {
    getStateData();
    getCategoryData();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchValue);
    }, 1000); // 500ms debounce

    // Cleanup timeout if query changes before 500ms
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    if (debouncedQuery) {
      getCategoryData();
    }
  }, [debouncedQuery]);

  const handleFilters = () => {
    setValue('');
    setIsDisabled(false);
    setIsPaginationEnabled(true);
    getCategoryData();
  };

  const handleSearch = (value) => {
    setSearchValue(value); // Update state with the entered value
    console.log('Search Value:', value); // Log or handle the search logic here
  };


  const handleColumns = () => {
    const columns = [
      // {
      //   field: "id",
      //   headerName: "ID",
      //   width: 100,
      // },
      {
        field: 'state_name',
        headerName: 'State',
        width: 150,
      },
      {
        field: 'sap_id__c',
        headerName: 'Party Id',
        width: 200,
      },
      {
        field: 'firm_name__c',
        headerName: 'Party Name',
        width: 200,
      },
      {
        field: 'city__c',
        headerName: 'City',
        width: 150,
      },
      {
        field: 'pincode__c',
        headerName: 'Pincode',
        width: 150,
      },
      {
        field: 'mobile__c',
        headerName: 'Mobile',
        width: 200,
      },
      {
        field: 'start_date__c',
        headerName: 'Start Date',
        width: 200,
      },
      {
        field: 'end_date__c',
        headerName: 'End date',
        width: 200,
      },
      {
        field: 'status',
        headerName: 'Status',
        width: 200,
      },

      {
        field: 'view',
        headerName: 'View Documents',
        width: 150,
        sortable: false,
        filterable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => (
          <Tooltip title='Preview'>
            <IconButton size='small' onClick={() => onView(params.row)}>
              <VisibilityOutlinedIcon />
            </IconButton>
          </Tooltip>
        ),
      },
    ];

    return columns;
  };
  const initialDrawerState = JSON.parse(localStorage.getItem('isDrawerOpen'));

  // JSON.parse(localStorage.getItem('isDrawerOpen'))

  const [drawerOpen, setDrawerOpen] = useState(
    isMobile ? false : initialDrawerState
  );

  const rows = distributorData.map((item, index) => ({
    id: item.sfid,
    state_name: item.state_name,
    sap_id__c: item.sap_id__c,
    sfid: item.sfid,
    city__c: item.city__c,
    pincode__c: item.pincode__c,
    firm_name__c: item.firm_name__c,
    mobile__c: item.mobile__c,
    start_date__c: item.start_date__c,
    end_date__c: item.end_date__c,
    status: item.downloaded__c ? 'Downloaded' : 'Not Downloaded',
  }));
  useEffect(() => {
    localStorage.setItem('isDrawerOpen', drawerOpen);
  }, [drawerOpen]);

  // const clearDateFilter = async () => {
  //   setSearchValue('');
  //   setSelectedState('');
  //   setSelectedSFID('');
  //   setSelectedQuarter('Q1');
  //   handleQuarterChange('Q1');
  //   setIsPaginationEnabled(true);
  //   setValue('');
  //   setSelectedRowSfids([]);
  //   setSelectedRowsMap({});
  //   setSelectedRowIds([]);
  //   setSelectedRows([]);
  //   setSelectedDownloadStatus('Not Downloaded');

  //   getCategoryData();
  // };

  // Option 1: Pass the next values directly to getCategoryData (recommended)
  const clearDateFilter = () => {
    const next = {
      searchValue: '',
      selectedState: '',
      selectedSFID: '',
      selectedQuarter: 'Q1',
      isPaginationEnabled: true,
      value: '',
      selectedRowSfids: [],
      selectedRowsMap: {},
      selectedRowIds: [],
      selectedRows: [],
      selectedDownloadStatus: 'Not Downloaded',
    };

    setSearchValue(next.searchValue);
    setSelectedState(next.selectedState);
    setSelectedSFID(next.selectedSFID);
    setSelectedQuarter(next.selectedQuarter);
    handleQuarterChange(next.selectedQuarter);
    setIsPaginationEnabled(next.isPaginationEnabled);
    setValue(next.value);
    setSelectedRowSfids(next.selectedRowSfids);
    setSelectedRowsMap(next.selectedRowsMap);
    setSelectedRowIds(next.selectedRowIds);
    setSelectedRows(next.selectedRows);
    setSelectedDownloadStatus(next.selectedDownloadStatus);
    setIsDisabled(true);

    getCategoryData1(next);
  };

  // getCategoryData should read from params, not state
  const getCategoryData1 = async (params = {}) => {
    const {
      searchValue,
      selectedState,
      selectedSFID,
      selectedQuarter,
      isPaginationEnabled,
      value,
      selectedRowSfids,
      selectedRowsMap,
      selectedRowIds,
      selectedRows,
      selectedDownloadStatus,
    } = params;

    try {
      let isDownload;
      if (selectedDownloadStatus === 'Not Downloaded') {
        isDownload = false;
      } else if (selectedDownloadStatus === 'Downloaded') {
        isDownload = true;
      } else {
        isDownload = selectedDownloadStatus;
      }

      const { startDate2, endDate2 } = handleQuarterChange('Q1');

      setIsloader(true);
      const response = await window.Platform.database.getDistributorDetails({
        searchField: '',
        pageNumber: 1,
        startDate: startDate2,
        endDate: endDate2,
        agree__c: agreeDisagree === 'agree',
        state__c: '',
        downloaded__c: false,
      });
      setIsloader(false);

      if (response.data) {
        setDistributorData(response.data.data);
        setRowCount(response.data.count[0].count);
      }
    } catch (error) {
      setIsloader(false);
      console.error(error);
    }
  };

  const handleRadioChange = async (event) => {
    const value = event.target.value;
    setValue((prev) => (prev === value ? '' : value));
    setIsPaginationEnabled(false);
    setSelectedOption(value);
    setLoading(true);
    setDataType(true);
    setSelectedRowIds([]);

    let isDownload;
    if (selectedDownloadStatus === 'Not Downloaded') {
      isDownload = false;
    } else if (selectedDownloadStatus === 'Downloaded') {
      isDownload = true;
    } else {
      isDownload = selectedDownloadStatus;
    }

    const response = await window.Platform.database.getDistributorDetails({
      searchField: searchValue,
      pageNumber: paginationModel.page + 1,
      startDate: startDate1,
      endDate: endDate1,
      agree__c: agreeDisagree === 'agree',
      state__c: selectedSFID,
      dataType: true,
      downloaded__c: isDownload,
    });
    setIsloader(false);
    if (response.data) {
      setDistributorData(response.data.data);
      setDistributorData1(
        response.data.data.map((item, index) => ({
          id: index,
          state_name: item.state_name,
          sap_id__c: item.sap_id__c,
          sfid: item.sfid,
          city__c: item.city__c,
          pincode__c: item.pincode__c,
          firm_name__c: item.firm_name__c,
          mobile__c: item.mobile__c,
          start_date__c: item.start_date__c,
          end_date__c: item.end_date__c,
          status: item.downloaded__c ? 'Downloaded' : 'Not Downloaded',
        }))
      );
      setRowCount(response.data.count[0].count);
    }
    setLoading(false);
  };

  const currentYearValue = dayjs().year();
const [selectedYear, setSelectedYear] = useState(currentYearValue);
  const getAvailableQuarters = () => {
    if (selectedYear === currentYearValue) {
      return ['Q1', 'Q2', 'Q3', 'Q4'];
    }
    return ['Q4']; // Only last quarter for 2025
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);

    let updatedQuarter = selectedQuarter;

    if (year !== currentYearValue) {
      updatedQuarter = 'Q4';
      setSelectedQuarter('Q4');
    }

    handleQuarterChange(updatedQuarter, year);
  };
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        minHeight: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}
        <CustomHeader name='financial-report' />
        <Box sx={{ px: 3 }}>
          <Box>
            <Card sx={{ padding: '20px', borderRadius: '10px', marginTop: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    placeholder='Search...'
                    value={searchValue}
                    onChange={(e) => handleSearch(e.target.value)}
                    size='medium'
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={selectedDownloadStatus}
                      onChange={(e) => handleDownloadStatusChange(e)}
                      renderValue={(selected) => {
                        if (typeof selected === 'boolean') {
                          return selected ? 'Downloaded' : 'Not Downloaded';
                        } else {
                          return selected;
                        }
                      }}
                    >
                      {['Downloaded', 'Not Downloaded'].map((status) => (
                        <MenuItem key={status} value={status}>
                          {status}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={selectedState}
                      onChange={(e) => handleStateChange(e)}
                      renderValue={(selected) =>
                        selected ? selected : 'Select State'
                      }
                    >
                      <MenuItem value='' disabled>
                        Select State
                      </MenuItem>
                      {states.map((state) => (
                        <MenuItem key={state.sfid} value={state.name__c}>
                          {state.name__c}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <Select
                      value={selectedQuarter}
                      onChange={(e) => handleQuarterChange(e.target.value)}
                    >
                      <MenuItem value='Q1'>Quarter 1 (April to June)</MenuItem>
                      <MenuItem value='Q2'>
                        Quarter 2 (July to September)
                      </MenuItem>
                      <MenuItem value='Q3'>
                        Quarter 3 (October to December)
                      </MenuItem>
                      <MenuItem value='Q4'>
                        Quarter 4 (January to March)
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid> */}
              <Grid item xs={12} sm={6} md={4}>
  <Grid container spacing={1}>

    {/* Year FIRST */}
    <Grid item xs={6}>
      <FormControl fullWidth>
        <Select
          value={selectedYear}
          onChange={(e) => handleYearChange(e.target.value)}
        >
          <MenuItem value={currentYearValue}>
            {currentYearValue}
          </MenuItem>
          <MenuItem value={2025}>2025</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    {/* Quarter SECOND */}
    <Grid item xs={6}>
      <FormControl fullWidth>
        <Select
          value={selectedQuarter}
          onChange={(e) =>
            handleQuarterChange(e.target.value, selectedYear)
          }
        >
          {getAvailableQuarters().map((q) => (
            <MenuItem key={q} value={q}>
              {q === 'Q1' && 'Quarter 1 (April to June)'}
              {q === 'Q2' && 'Quarter 2 (July to September)'}
              {q === 'Q3' && 'Quarter 3 (October to December)'}
              {q === 'Q4' && 'Quarter 4 (January to March)'}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

  </Grid>
</Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    value={startDate1 || ''}
                    placeholder='Start Date'
                    disabled
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    value={endDate1 || ''}
                    placeholder='End Date'
                    disabled
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl
                    component='fieldset'
                    sx={{
                      borderRadius: '40px',
                      padding: '5px 10px',
                      width: '100%',
                    }}
                  >
                    <RadioGroup row value={value} onChange={handleRadioChange}>
                      <FormControlLabel
                        value='all'
                        control={
                          <Radio value='all' sx={{ color: '#85c225' }} />
                        }
                        label='Get all records'
                        labelPlacement='end'
                        sx={{
                          '& .MuiFormControlLabel-label': {
                            color: '#85c225',
                            textAlign: 'left',
                            whiteSpace: 'nowrap',
                          },
                        }}
                        disabled={!selectedState}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Button
                    // startIcon={<GetAppIcon />}
                    size='large'
                    variant='contained'
                    onClick={() => handleFilters()}
                    sx={{ height: 50 }}
                    fullWidth
                  >
                    Apply Filters
                  </Button>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  {isloader && <OpaqueLoading />}
                  <Button
                    startIcon={<GetAppIcon />}
                    size='large'
                    variant='contained'
                    onClick={() => exportData()}
                    sx={{ height: 50 }}
                    fullWidth
                    disabled={!startDate && !endDate && !selectedState}
                  >
                    Download documents
                  </Button>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Button
                    startIcon={<GetAppIcon />}
                    size='large'
                    variant='contained'
                    onClick={() => exportData('excel')}
                    sx={{ height: 50 }}
                    fullWidth
                    disabled={!startDate && !endDate && !selectedState}
                  >
                    Export excel
                  </Button>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Box
                    display='flex'
                    flexDirection='row-reverse'
                    alignItems='center'
                    justifyContent='flex-end'
                    gap={1}
                  >
                    <Typography
                      variant='subtitle2'
                      sx={{
                        fontWeight: 500,
                        color: '#85c225',
                      }}
                    >
                      Refresh Data
                    </Typography>

                    <IconButton
                      size='large'
                      // disabled={
                      //   (!selectedState &&
                      //     !searchValue
                      //     ) ||
                      //   isloader
                      // }
                      disabled={isDisabled || isloader}
                      onClick={() => clearDateFilter()}
                      sx={{ alignSelf: 'flex-start' }}
                    >
                      <RefreshIcon fontSize='large' />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>

              <br />

              {/* <div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '20px',
                    paddingTop: '4px',
                    marginBottom: '10px',
                  }}
                >
                  <input
                    type='text'
                    placeholder='Search...'
                    style={{
                      flex: '1',
                      padding: '8px',
                      fontSize: '16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                    }}
                    value={searchValue}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <select
                    style={{
                      padding: '8px',
                      fontSize: '16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      background: '#fff',
                    }}
                    value={selectedState}
                    onChange={(e) => handleStateChange(e)}
                  >
                    <option value='' disabled selected>
                      Select State
                    </option>
                    {states.map((state) => (
                      <option key={state.sfid} value={state.name__c}>
                        {state.name__c}
                      </option>
                    ))}
                  </select>
                  <IconButton
                    size='large'
                    variant='contained'
                    disabled={(!selectedState && !searchValue) || isloader}
                    onClick={() => clearDateFilter()}
                  >
                    <RefreshIcon fontSize='large' />
                  </IconButton>
                  {isloader && <OpaqueLoading />}
                  <Button
                    startIcon={<GetAppIcon />}
                    size='large'
                    style={{
                      height: '50px',
                      padding: '8px 16px',
                      fontSize: '16px',
                      borderRadius: '4px',
                    }}
                    onClick={() => exportData()}
                    variant='contained'
                  >
                    Download
                  </Button>
                  <Button
                    startIcon={<GetAppIcon />}
                    size='large'
                    style={{
                      height: '50px',
                      padding: '8px 16px',
                      fontSize: '16px',
                      borderRadius: '4px',
                    }}
                    onClick={() => exportData()}
                    variant='contained'
                  >
                    Export
                  </Button>
                </div>
              </div>
              <div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '20px',
                    marginBottom: '10px',
                  }}
                >
                  <select
                    style={{
                      flex: '1',
                      padding: '8px',
                      fontSize: '16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                    }}
                    value={selectedQuarter}
                    onChange={(e) => handleQuarterChange(e.target.value)}
                  >
                    <option value='Q1'>Quarter 1 (April to June)</option>
                    <option value='Q2'>Quarter 2 (July to September)</option>
                    <option value='Q3'>Quarter 3 (October to December)</option>
                    <option value='Q4'>Quarter 4 (January to March)</option>
                  </select>
                  <input
                    type='text'
                    value={startDate1 || ''}
                    placeholder='Start Date'
                    style={{
                      padding: '8px',
                      fontSize: '16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: '#f5f5f5',
                    }}
                    disabled
                  />
                  <input
                    type='text'
                    value={endDate1 || ''}
                    placeholder='End Date'
                    style={{
                      padding: '8px',
                      fontSize: '16px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      backgroundColor: '#f5f5f5',
                    }}
                    disabled
                  />

                  <FormControl
                    component='fieldset'
                    sx={{
                      borderRadius: '40px',
                      padding: '5px 10px',
                      flexGrow: 1,
                      flexBasis: 0,
                      minWidth: 0,
                    }}
                  >
                    <RadioGroup row onChange={handleRadioChange}>
                      <FormControlLabel
                        value='all'
                        control={<Radio sx={{ color: '#85c225' }} />}
                        label='Get all record for selected date'
                        labelPlacement='end'
                        sx={{
                          '& .MuiFormControlLabel-label': {
                            color: '#85c225',
                            textAlign: 'left',
                            whiteSpace: 'nowrap',
                          },
                        }}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div> */}

              {view === 0 && (
                <DataGridContainer
                  style={{ height: rows.length > 0 ? '400px' : '300px' }}
                >
                  {isPaginationEnabled ? (
                    <DataGrid
                      rows={rows}
                      columns={handleColumns()}
                      checkboxSelection
                      // onRowClick={(params) => {
                      //   console.log("RowClick", params);
                      //   setSelectedRow(params.row);
                      //   setView(1);
                      // }}
                      rowSelectionModel={selectedRowSfids}
                      // onRowSelectionModelChange={(selectedRowIndices) => {
                      //   console.log('Selected Row Indices:', selectedRowIndices);
                      //   setSelectedRowIds(selectedRowIndices);
                      // }}
                      onRowSelectionModelChange={(newSelection) => {
                        setSelectedRowSfids((prev) => {
                          const currentPageSfids = rows.map((r) => r.sfid);
                          const removed = prev.filter(
                            (sfid) => !currentPageSfids.includes(sfid)
                          );
                          const added = newSelection.filter(
                            (sfid) => !removed.includes(sfid)
                          );
                          setSelectedRowsMap((prevMap) => {
                            const updatedMap = { ...prevMap };
                            currentPageSfids.forEach((sfid) => {
                              if (!newSelection.includes(sfid)) {
                                delete updatedMap[sfid];
                              }
                            });
                            rows.forEach((row) => {
                              if (newSelection.includes(row.sfid)) {
                                updatedMap[row.sfid] = row;
                              }
                            });
                            return updatedMap;
                          });
                          return [...removed, ...added];
                        });
                      }}
                      disableSelectionOnClick
                      disableRowSelectionOnClick
                      paginationModel={paginationModel}
                      paginationMode='server'
                      onPaginationModelChange={setPaginationModel}
                      rowCount={rowCount}
                      components={{
                        Toolbar: CustomToolbar,
                      }}
                      componentsProps={{
                        toolbar: {
                          onAgreeDisagree: setAgreeDisagree,
                        },
                      }}
                    />
                  ) : (
                    <DataGrid
                      // data
                      rows={distributorData1}
                      columns={handleColumns()}
                      // selection
                      checkboxSelection
                      getRowId={(row) => row.id} // <-- use sfid as the unique id
                      disableRowSelectionExcludeModel // <-- predictable include-only selection model
                      rowSelectionModel={selectedRowIds}
                      onRowSelectionModelChange={(newSelection) => {
                        // ✅ simplest: just save what the grid sends

                        // 1) Save IDs
                        setSelectedRowIds(newSelection);

                        // 2) Save OBJECTS (filter rows by selected ids)
                        const idSet = new Set(newSelection);
                        const selectedObjects = distributorData1.filter((r) =>
                          idSet.has(r.id)
                        );
                        setSelectedRows(selectedObjects);

                        // 3) Optional: map keyed by id for O(1) lookup
                        setSelectedRowsMap(
                          Object.fromEntries(
                            selectedObjects.map((r) => [r.id, r])
                          )
                        );

                        // (optional) keep a map of selected rows for quick access
                        // setSelectedRowsMap((prev) => {
                        //   const next = { ...prev };
                        //   // Clear map for current page first
                        //   for (const r of distributorData1) delete next[r.sfid];
                        //   // Add selected from current page
                        //   for (const r of distributorData1) {
                        //     if (newSelection.includes(r.sfid)) next[r.sfid] = r;
                        //   }
                        //   return next;
                        // });
                      }}
                      disableSelectionOnClick
                      disableRowSelectionOnClick
                      // pagination (client-side)
                      paginationModel={paginationModel}
                      paginationMode='server'
                      onPaginationModelChange={setPaginationModel}
                      // If you want to hide the footer controls while still paginating, keep this:
                      hideFooterPagination
                      // In client mode, rowCount is not used; you can remove it or leave it harmlessly.
                      // rowCount={rowCount}

                      // toolbar
                      components={{
                        Toolbar: CustomToolbar,
                      }}
                      componentsProps={{
                        toolbar: {
                          onAgreeDisagree: setAgreeDisagree,
                        },
                      }}
                    />
                  )}
                </DataGridContainer>
              )}
            </Card>
          </Box>
        </Box>
      </Container>

      {/* <Dialog
        open={openDialog2}
        onClose={() => {
          setOpenDialog2(false);
          getCategoryData();
        }}
        maxWidth='md'
        fullWidth
      >
        <DialogTitle>
          Preview
          {/* {hasItems && (
            <Stack direction='row' spacing={1} sx={{ float: 'right' }}>
              <Tooltip title='Open in new tab'>
                <IconButton
                  onClick={() => openInNewTab(currentUrl.file_url__c)}
                  size='small'
                >
                  <OpenInNewIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title='Previous'>
                <span>
                  <IconButton onClick={prev} size='small' disabled={!hasItems}>
                    <ArrowBackIosNewIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title='Next'>
                <span>
                  <IconButton onClick={next} size='small' disabled={!hasItems}>
                    <ArrowForwardIosIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          )} */}
      {/* </DialogTitle>

        <DialogContent dividers> */}
      {/* {!hasItems ? (
            <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
              No files to preview
            </Box>
          ) :  */}
      {/* {isPdf ? (
            <PdfIframe url={currentUrl?.file_url__c} />
          ) : (
            <Box sx={{ textAlign: 'center' }}>
              <img
                src={currentUrl.file_url__c}
                alt={`Preview`}
                style={{
                  maxWidth: '100%',
                  maxHeight: '80vh',
                  display: 'inline-block',
                }}
                onClick={() => openInNewTab(currentUrl.file_url__c)}
              />
            </Box>
          )} */}

      {/* Thumbnails / quick navigation (optional) */}
      {/* {hasItems && (
            <Stack
              direction='row'
              spacing={1}
              sx={{
                mt: 2,
                overflowX: 'auto',
                alignItems: 'center',
                pb: 1,
              }}
            >
              {imageUrls.map((u, i) => {
                const pdf = u.file_url__c.toLowerCase().endsWith('.pdf');
                return (
                  <Box
                    key={`${i}-${u.file_url__c}`}
                    onClick={() => setIndex(i)}
                    sx={{
                      border:
                        i === index ? '2px solid #1976d2' : '1px solid #ddd',
                      borderRadius: 1,
                      p: 0.5,
                      cursor: 'pointer',
                      flex: '0 0 auto',
                    }}
                  >
                    {pdf ? (
                      <Box
                        sx={{
                          width: 90,
                          height: 60,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: '#f5f5f5',
                          color: '#d32f2f',
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        PDF
                      </Box>
                    ) : (
                      <img
                        src={u.file_url__c}
                        alt={`thumb-${i}`}
                        style={{ width: 90, height: 60, objectFit: 'cover' }}
                        loading='lazy'
                      />
                    )}
                  </Box>
                );
              })}
            </Stack>
          )} */}
      {/* </DialogContent> */}
      {/*</Dialog> */}

      <Dialog
        open={openDialog2}
        onClose={() => {
          setOpenDialog2(false);
          // getCategoryData();
        }}
        maxWidth='md'
        fullWidth
        onContextMenu={(e) => e.preventDefault()}
      >
        <DialogTitle>
          Preview
          {/* {hasItems && (
            <Stack direction='row' spacing={1} sx={{ float: 'right' }}>
              <Tooltip title='Open in new tab'>
                <IconButton
                  size='small'
                  onClick={() => openInNewTab(imageUrl.file_url__c)}
                >
                  <OpenInNewIcon />
                </IconButton>
              </Tooltip>
            </Stack>
          )} */}
        </DialogTitle>

        <DialogContent dividers>
          {/* {!hasItems ? (
            <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
              No files to preview
            </Box> */}
          {/* ) :  */}
          {isPdf ? (
            <PdfIframe url={imageUrl} />
          ) : (
            <Box sx={{ textAlign: 'center' }}>
              <img
                src={imageUrl}
                alt='Preview'
                style={{
                  maxWidth: '100%',
                  maxHeight: '80vh',
                  // cursor: 'pointer',
                }}
              // onClick={() => openInNewTab(imageUrl)}
              />
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FinanceManagement;
